module.exports = __webpack_public_path__ + "img/waf-d.7ee62e1.svg";